import { lazy, Suspense } from "react";
import { GLOBAL_CONFIG } from "@/global-config";
import { LineLoading } from "@/components/loading";
import LoginAuthGuard from "@/routes/components/login-auth-guard";
import type { RouteObject } from "react-router";
import { getBackendDashboardRoutes } from "./backend";
import { getFrontendDashboardRoutes } from "./frontend";

const DashboardLayout = lazy(() => import("@/layouts/dashboard"));

const getRoutes = (): RouteObject[] => {
	if (GLOBAL_CONFIG.routerMode === "frontend") {
		return getFrontendDashboardRoutes();
	}
	return getBackendDashboardRoutes();
};

export const dashboardRoutes: RouteObject[] = [
	{
		path: "/",
		element: (
			<LoginAuthGuard>
				<Suspense fallback={<LineLoading />}>
					<DashboardLayout />
				</Suspense>
			</LoginAuthGuard>
		),
		children: getRoutes(),
	},
];
